// extracted by mini-css-extract-plugin
export var cardLayout = "_9k-1";
export var paginationContainer = "_9k-0";